import { render, staticRenderFns } from "./SSTreatmentView.vue?vue&type=template&id=bc2a054c&scoped=true&"
import script from "./SSTreatmentView.vue?vue&type=script&lang=js&"
export * from "./SSTreatmentView.vue?vue&type=script&lang=js&"
import style0 from "./SSTreatmentView.vue?vue&type=style&index=0&id=bc2a054c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2a054c",
  null
  
)

export default component.exports